import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

/**
 * Input component
 */
const Input = forwardRef(({
  id,
  label,
  type = 'text',
  error,
  fullWidth = false,
  ...rest
}, ref) => {
  return (
    <InputWrapper fullWidth={fullWidth}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <StyledInput
        id={id}
        type={type}
        ref={ref}
        hasError={!!error}
        {...rest}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputWrapper>
  );
});

Input.displayName = 'Input';

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
`;

const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
  color: ${theme.colors.text};
`;

const StyledInput = styled.input`
  padding: 0.5rem 0.75rem;
  border: 1px solid ${({ hasError }) => 
    hasError ? theme.colors.danger : theme.colors.inputBorder};
  border-radius: ${theme.borderRadius.md};
  font-size: 1rem;
  outline: none;
  transition: border ${theme.transitions.fast};
  background-color: ${theme.colors.input};
  
  &:focus {
    border-color: ${({ hasError }) => 
      hasError ? theme.colors.danger : theme.colors.inputFocus};
    box-shadow: 0 0 0 2px ${({ hasError }) => 
      hasError ? `${theme.colors.danger}20` : `${theme.colors.inputFocus}20`};
  }
  
  &:disabled {
    background-color: ${theme.colors.disabled};
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.p`
  color: ${theme.colors.danger};
  font-size: 0.75rem;
  margin-top: 0.25rem;
  margin-bottom: 0;
`;

export default Input;
